import { styled } from '@mui/material';
import { Card, CardFooter, Subtitle1 } from '@fluentui/react-components';

export const MessageWrapper = styled('div')`
  display: flex;
  justify-content: center;
`;

export const MessageBox = styled('div')`
  margin-top: 20vh;
  width: 50vw;
  min-width: 300px;
  max-width: 600px;
`;

export const MessageTitle = styled(Subtitle1)`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const MessageCardFooter = styled(CardFooter)`
  justify-content: flex-end;
`;

export const BetaPageContainer = styled('div')`
  margin: 1rem 2rem 0 2rem;
  padding-top: 1rem;
  height: ${(props) => props.headerHeight}px;
`;

export const BetaPageTitleContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export const FeatureCard = styled(Card)`
  min-width: 275px;
  max-width: 33%;
`;

export const RestrictedAccessWrapper = styled('div')`
  margin: 3rem auto;
  max-width: 90%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const LoadingPageWrapper = styled('div')`
  margin-top: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DataLoaderWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;